require('gsap/TweenMax');
require('gsap/ScrollToPlugin');